<idt-common-styles-render
  *ngIf="settings"
  [styles]="settings.styles">

  <div class="list-title">{{ listTitle }}</div>

  <ng-container *ngIf="isOrdered">
    <ol
      class="list"
      [class]="listClass">
      <ng-container *ngTemplateOutlet="list"></ng-container>
    </ol>
  </ng-container>

  <ng-container *ngIf="!isOrdered">
    <ul
      class="list"
      [class]="listClass">
      <ng-container *ngTemplateOutlet="list"></ng-container>
    </ul>
  </ng-container>

</idt-common-styles-render>

<ng-template #list>
  <li *ngFor="let item of listContent; trackBy: trackByIndex">
    <render-link
      *ngIf="item.link !== null"
      [link]="item.link"
      (renderLinkEvent)="itemClicked(item.value)">
      {{ item.value }}
    </render-link>
    <span *ngIf="item.link === null">{{ item.value }}</span>
  </li>
</ng-template>
